import {AfterViewInit, Component, OnInit} from '@angular/core';
import {AdminNavbarComponent} from "../admin-navbar/admin-navbar.component";
import {AdminSidebarComponent} from "../admin-sidebar/admin-sidebar.component";
import * as feather from 'feather-icons';
import packageInfo from '../../../../package.json';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-admin-wrapper',
  imports: [
    AdminNavbarComponent,
    AdminSidebarComponent,
    CommonModule
  ],
  templateUrl: './admin-wrapper.component.html',
  styleUrl: './admin-wrapper.component.scss'
})
export class AdminWrapperComponent implements OnInit, AfterViewInit {

  year: any
  show: boolean = true;
  version: string = packageInfo.version;

  updateShow(newShowValue: boolean) {
    this.show = newShowValue; // Update the `show` value in the parent component
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

  ngAfterViewInit(): void {
    feather.replace();
  }

}
